export const carersAllowance = [
    {
        value: '1',
        label: 'Yes',
        option: 'A',
        instruction: '',
    },
    {
        value: '0',
        label: 'No',
        option: 'B',
        instruction: '',
    },
];
